/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {IPlaylist} from 'services/on-demand.service';
import {
  PLAYLIST_FETCHING,
  PLAYLIST_FETCHING_DONE,
  PLAYLIST_FETCHING_ERROR,
  PlaylistActionsType
} from 'store/action';
import {IPortalError} from 'utility/error-handler';

export interface IPlaylistState {
    isFetching: boolean;
    error: null | IPortalError;
    playlists: IPlaylist[];
}

const defaultState = {
  isFetching: false,
  error: null,
  playlists: []
};
const playlistReducer: Reducer<Readonly<IPlaylistState>, PlaylistActionsType> = (
  state: IPlaylistState = defaultState,
  action: PlaylistActionsType
) => {
  switch (action.type) {
    case PLAYLIST_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case PLAYLIST_FETCHING_DONE: {
      return {
        ...state,
        isFetching: false,
        error: null,
        playlists: action.payload
      };
    }

    case PLAYLIST_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default playlistReducer;